import { BoxProps } from '@chakra-ui/react';

export const RESPONSIVE_BOX_STYLES: BoxProps = {
  borderRadius: { base: 'lg', md: 'xl' },
  p: { base: 3, md: 4 },
  border: '1px solid',
  borderColor: 'dark.D100',
  transition: 'all 0.2s',
  _hover: {
    transform: 'translateY(-2px)',
    boxShadow: 'md',
  },
};

export const LOGO_BOX_STYLES: BoxProps = {
  p: { base: 0.5, md: 1 },
  bg: 'white',
  borderRadius: 'full',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  border: '2px solid',
  flexShrink: 0,
};

export const CARD_PALETTES = {
  match: {
    accentColor: 'green.G500',
    accentBg: 'green.G0',
    gradientBg: 'linear-gradient(135deg, #F0F8F7 0%, #B3DBD5 100%)',
    tagColorScheme: 'green',
  },
  concert: {
    accentColor: '#ff5b4e',
    accentBg: '#FFF5F5',
    gradientBg: 'linear-gradient(135deg, #FFF5F5 0%, #FFE5E3 50%, #FFD1CE 100%)',
    tagColorScheme: 'red',
  },
  generic: {
    accentColor: 'green.G500',
    accentBg: 'green.G0',
    gradientBg: 'linear-gradient(135deg, #F0F8F7 0%, #EAEBEB 100%)',
    tagColorScheme: 'green',
  },
};
